import { Component, OnInit, AfterContentChecked, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params, Router} from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { ContentService } from '../shared/content.service';
import { SearchService } from '../shared/search.service';
import { MetaService } from '../shared/meta.service';
import { Content } from '../shared/content';
import { CartService } from './cart.service';
import { UtilsService } from '../shared/utils.service';
import { ConfigService } from '../shared/config.service';
import { IntlService } from '../shared/intl.service';
import { NotificationService } from '../shared/notification.service';
import { isBrowser } from 'angular2-universal';

declare var $: any; 

@Component({
    template: require('./partials/content-record.html'),
    providers: [NotificationService]
})
export class ContentRecordComponent extends Content {

    mltContents: Object[] = [];
    qty: number = 1;
    previousUrl: string;

    constructor(private recordConfig: ConfigService, public location: Location, private recordIntlService: IntlService, private notification: NotificationService,private cartService: CartService, private searchService: SearchService, private elementRef: ElementRef, private utils: UtilsService, private recordMetaService: MetaService, private recordService: ContentService, private recordRoute: ActivatedRoute, private router: Router) {
        super(recordConfig, recordIntlService, recordMetaService, recordService, recordRoute);
        this.setType('record');
        this.cartService.setCookieExpiresInDays(this.config.data.CART.COOKIE_DAY_AGE);
    }
    
    addToCart(){
        this.cartService.update(this.content,this.qty);
        this.notification.notify('Le panier a été mis à jour');
    }
    removeFromCart(id){
        this.cartService.remove(id);
        this.notification.notify('Le panier a été mis à jour');
    }

    // Overrides super class init
    ngOnInit(){
        this.setCurrentLanguage();
        this.setContentAsync();
        this.contentAsync.subscribe(
            (record: any) => {
                if(!record) {
                    console.error('Content not set');
                } else if(record.error && record.error==404){
                    // Page not found
                    this.router.navigate(['page-not-found'],{relativeTo: this.recordRoute.parent});
                } else {
                    this.content = record;
                    // meta
                    this.setMeta();
                    // MLT
                    this.ready();
                    this.searchService.mlt('record', this.content._id).then(response => {
                        let indexData = response.hits;
                        // Retrieve info from db based on index ids
                        let ids:any = [];
                        for(let hit of indexData['hits'])
                            ids.push(hit._id);
                        if(ids.length>0) {
                            let idsString = ids.join(',');
                            this.recordService.findContents('record',idsString)
                            .then(res => {
                                this.mltContents = res;
                            });
                        }
                    });
                } 
            }
        );
    }

    ngAfterContentChecked(){
        super.ngAfterContentChecked();
        // JS file path must be configurable
        if (isBrowser) {
            this.utils.loadScripts(["/resources_front/assets/custom/popup-gallery-bundle.js"], this.elementRef.nativeElement);
        }
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/content-record.component.ts